<template>
    <v-card>
        <v-card-title>
                <div class="title">Cadastro de participante não vinculado à UNIFEBE</div>
        </v-card-title>        
        <v-card-text>
            <v-form ref="form" v-model="valid">
                <div v-if="!submitted">
                    <v-select label="Nacionalidade" v-model="person.nationality" prepend-icon=""
                        :items="nationalities" item-text="name" item-value="id"></v-select>  
                    <v-text-field :label="documentLabel" v-model="person.document" prepend-icon="assignment_ind"
                        :rules="rules.document" :mask="documentMask" required validate-on-blur></v-text-field>
                    <v-text-field label="Nome" v-model="person.name" prepend-icon="text_fields"
                        :rules="rules.name" required></v-text-field>
                    <v-text-field label="Data de Nascimento" v-model="person.birthDate" prepend-icon="date_range"
                        :rules="rules.date" mask="##/##/####" required validate-on-blur></v-text-field>
                    <v-text-field label="E-mail" v-model="person.email" prepend-icon="email"
                        :rules="rules.email" required validate-on-blur></v-text-field>                       
                    <v-flex xs12 class="text-xs-center">
                        <v-btn @click="submit" color="primary" dark large>Cadastrar</v-btn>
                    </v-flex>
                </div>
                <div v-if="submitted">
                    <v-alert :value="wasCreated" color="success">Seu cadastro foi realizado com sucesso.</v-alert>
                    <v-alert :value="alreadyExists" color="warning">Já existe um usuário cadastrado para o {{ documentLabel }} {{ person.document }} com o e-mail {{ exists.email }}.</v-alert>
                    <v-alert :value="canSendAccess && !accessSent" color="info">Se desejar, clique em <strong>Enviar acesso</strong> para receber no seu e-mail cadastrado um código e senha de acesso ao Sistema de Gestão de Bancas.</v-alert>
                    <v-flex xs12 class="text-xs-center" v-if="canSendAccess && !accessSent">
                        <v-btn @click="sendAccess" color="info" dark large>Enviar acesso</v-btn>
                    </v-flex>                        
                    <v-alert :value="accessSent" color="success">Um e-mail foi enviado para {{ accessSentTo }} com o código e senha para acesso ao Sistema de Gestão de Bancas.</v-alert>
                    <v-flex xs12 class="text-xs-center">
                        <v-btn to="/entrar/visitante" color="primary" dark large>Fazer login</v-btn>
                    </v-flex>            
                </div>
                <v-alert :value="true" color="error" v-if="error">{{ error }}</v-alert>
            </v-form>
        </v-card-text>            
        <v-card-actions v-if="showActions">
            <slot name="actions"></slot>
        </v-card-actions>      
    </v-card>        
</template>

<script>
    import RegisterExternalMixin from './RegisterExternalMixin'  

    export default {
        name: 'RegisterExternalListener',
        mixins: [RegisterExternalMixin],
        data() {
            return {
                submitted: false,
                wasCreated: false,              
                alreadyExists: false,
                accessSentTo: ''
            }
        },
        methods: {
            submit() {
                this.error = ''
                this.submitted = false
                this.wasCreated = false
                this.alreadyExists = false
                this.canSendAccess = false
                this.accessSent = false
                this.accessSentTo = ''
                if (this.valid) {
                    this.$http.post('registerExternalListener', this.person).then(response => {
                        if (typeof response.data.status !== 'undefined') {
                            if (response.data.status == 'ok') {
                                this.submitted = true   
                                this.wasCreated = true
                                this.accessSent = true
                                this.accessSentTo = this.person.email
                                this.$emit('registered', { id: this.person.document, name: this.person.name, type: '4' })
                            } else if (response.data.status == 'already_exists') {
                                this.submitted = true
                                this.alreadyExists = true                                
                                this.canSendAccess = true
                                this.exists = response.data.user
                            } else {
                                this.handleErrors(response.data.errors)
                            }
                        } else {
                            this.handleErrors(response.data.errors)
                        }
                    }, response => {
                        this.handleErrors(response.data.errors)
                    }) 
                } else {
                    this.error = 'Verifique as informações no formulário e tente novamente.'
                }             
            },
            sendAccess() {
                if (!this.canSendAccess || !!!this.person.document) return false
                this.$http.post('sendAccessToExternalListener', { document: this.person.document }).then(response => {
                    if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                            this.accessSent = true
                            this.accessSentTo = response.data.messageSentTo
                    } else {
                        this.handleErrors(response.data.errors)
                    }
                }, response => {
                    this.handleErrors(response.data.errors)
                }) 
            },          
        }
    }
</script>


// WEBPACK FOOTER //
// RegisterExternalListener.vue?6b194ac7